var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
const StyledList = styled.ul `
  list-style: none;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
`;
const StyledListItem = styled.li `
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-top: 1px solid #ccc;
  &.hover:hover {
    background: #f4f4f4;
  }
  &.dragging {
    border-top: none;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  }
  &.button {
    cursor: pointer;
  }
  .list-item-icon {
    display: flex;
    align-items: center;
    svg {
      margin-left: -2px;
      color: #ccc;
    }
  }
  .list-item-line {
    display: flex;
    align-items: center;
    .list-item-primary {
      flex: 1;
      display: flex;
      align-items: center;
    }
    .list-item-secondary-action {
      padding-right: 4px;
    }
  }
`;
export const ConfigList = forwardRef((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (React.createElement(StyledList, Object.assign({ ref: ref, className: `config-list-item${className ? ` ${className}` : ''}` }, props), children));
});
export const ConfigListItem = forwardRef((_a, ref) => {
    var { hover, icon, iconProps, primary, secondaryAction, className, children, onClick } = _a, props = __rest(_a, ["hover", "icon", "iconProps", "primary", "secondaryAction", "className", "children", "onClick"]);
    return (React.createElement(StyledListItem, Object.assign({ ref: ref, className: [
            'config-list-item',
            hover && 'hover',
            onClick && 'button',
            className
        ]
            .filter(c => c)
            .join(' '), onClick: onClick }, props),
        React.createElement("div", { className: 'list-item-line' },
            icon && (React.createElement("div", Object.assign({ className: 'list-item-icon' }, iconProps), icon)),
            primary && React.createElement("div", { className: 'list-item-primary' }, primary),
            secondaryAction && (React.createElement("div", { className: 'list-item-secondary-action' }, secondaryAction))),
        children && React.createElement("div", { className: 'list-item-body' }, children)));
});
//# sourceMappingURL=ConfigList.js.map